import React from "react";
import {SelectElementModelFE} from "../../../api/types/generic";
import {FormAutocomplete} from "../../../common/form-fields";
import {useTranslation} from "react-i18next";

export default ({
                    nestIndex,
                    options,
                    handleChange,
                    name,
                    readOnly
                }: {
    nestIndex: number,
    options: any,
    handleChange: Function,
    name: string,
    readOnly: boolean
}) => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <FormAutocomplete
            name={`associations.${nestIndex}.${name}`}
            label={`${t("pricing:rateProductCodeLocationGroup.form.labels." + name)}`}
            options={options}
            isOptionEqualToValue={(option: SelectElementModelFE, value: SelectElementModelFE) => {
                return value?.code === option?.code;
            }}
            readOnly={readOnly}
            multiple={true}
            handleChange={(value: SelectElementModelFE[]) => handleChange(value, nestIndex)}
        />
    );
};
